import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }

import { getCurrentInstance, withDefaults, computed } from 'vue';
import { useRouter } from 'vue-router';
import { getTokenKey, getToken, getUserCache } from '@/plugins/cookie';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLink',
  props: {
    to: { default: '' },
    target: { default: '' },
    applink: { type: Boolean, default: true },
    disable: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { to: string, target: string, applink: boolean, disable: boolean };

const { proxy }: any = getCurrentInstance();

const httpName = proxy.$httpName;
const { id, name, avatar } = JSON.parse(getUserCache() as string);
const urlStr = `${getTokenKey()}=${getToken()}&lighosId=${id}&lighosName=${name}&lighosHeadUrl=${avatar}`;
const tokenParam = computed(() => (props.to.includes('?') ? `&${urlStr}` : `?${urlStr}`));
const hasHttp = computed(() => (props.applink ? props.to.includes('http') : true));
const url = computed(() => {
  return props.applink ? props.to : httpName + props.to + tokenParam.value;
});
// 站外跳转 防止嵌套导致的冒泡事件
const outsideSkip = (urlName: string, traget?: string) => {
  if (traget || hasHttp.value) {
    console.log(11111);
    
    window.open(urlName);
  } else {
    console.log(2222222);
    window.location.href = urlName;
  }
};

const router = useRouter();
// 站内跳转
const insideSkip = (urlName: string, traget?: string) => {
  console.log(333333);
  if (traget === '_blank') {
    console.log(4444);
    
    const routerJump = router.resolve(urlName);
    window.open(routerJump.href, '_blank');
  } else {
    console.log(urlName,5555);
    router.push(urlName);
    // window.location.href = urlName;
  }
  window.scrollTo(0, 0);
};

return (_ctx: any,_cache: any) => {
  return (props.disable)
    ? (_openBlock(), _createElementBlock("a", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : (_unref(hasHttp))
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (outsideSkip(_unref(url), props.target)), ["stop"]))
        }, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : (_openBlock(), _createElementBlock("a", {
          key: 2,
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (insideSkip(_unref(url), props.target)), ["stop"]))
        }, [
          _renderSlot(_ctx.$slots, "default")
        ]))
}
}

})